module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tara Taylor Quinn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" Tara Taylor Quinn, is a "), _c('I', [_vm._v("USA Today")]), _vm._v("–bestselling author of one hundred novels, which have been translated into twenty languages and has sold more than seven million copies. Known for her intense emotional fiction, Quinn’s novels have received critical acclaim, including the 2008 National Reader’s Choice Award, and five RITA Award finalist, and a former president and board director of the Romance Writers of America. She has appeared often on local and national TV, including "), _c('I', [_vm._v("CBS Sunday Morning")]), _vm._v(". For additional offers, news, and contests, visit the author at tarataylorquinn.com. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BazAy/tc-custom/9781426862663.jpg?1725275240851",
      "alt": "This image is the cover for the book Merry Christmas, Babies"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Merry Christmas, Babies\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Business hotshot Elise Richardson is successful, beautiful, singleand her biological clock is clanging like a church bell. So independent Elise takes matters into her own hands and now she's pregnant—with quadruplets!"), _c('br'), _c('br'), _vm._v("Her business partner and best friend, Joe Bennett, can't believe she's going to be a mom—times four! There's no way "), _c('i', [_vm._v("he's")]), _vm._v(" ready for the chaos of parenthood. Being one of seven children has taught him that much."), _c('br'), _c('br'), _vm._v("But now that Elise's doctor says she shouldn't be home alone, Joe's ready to move in. Strictly as a friend, of course. At least until Christmas")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0